import React from 'react';
import PropTypes from 'prop-types';
import Box from 'common/src/components/Box';
import Text from 'common/src/components/Text';
import Heading from 'common/src/components/Heading';
//import Button from 'common/src/components/Button';
//import Input from 'common/src/components/Input';
import Container from 'common/src/components/UI/Container';

import NewsletterWrapper, { ContactFormWrapper } from './newsletter.style';

const Newsletter = ({
  sectionWrapper,
  textArea,
  buttonArea,
  //buttonStyle,
  title,
  description,
}) => {
  return (
    <Box {...sectionWrapper} as="section">
      <NewsletterWrapper>
        <Container>
          <Box {...textArea}>
            <Heading content="Get in Touch with Archer Health" {...title} />
            <Text
              content="Interested in learning what an onsite healthcare clinic can do for your organization? Whether you're ready to get started or still exploring options, we're here to help."
              {...description}
            />
            <h3>Reach out to our team and find out more about reducing healthcare costs and elevating employee benefits with Archer Health.</h3>
          </Box>
          <Box {...buttonArea}>
          <ContactFormWrapper>
            <p className="cta">
              Give Us a Call<br/>
              <strong>601-565-0075</strong>
            </p>
            {/* 
              <Input
                inputType="email"
                label="Email address"
                iconPosition="right"
                isMaterial={true}
                className="email_input"
              />
              <Button {...buttonStyle} title="Get access" />
             */}
             </ContactFormWrapper>
          </Box>
        </Container>
      </NewsletterWrapper>
    </Box>
  );
};

Newsletter.propTypes = {
  sectionWrapper: PropTypes.object,
  textArea: PropTypes.object,
  buttonArea: PropTypes.object,
  buttonStyle: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
};

Newsletter.defaultProps = {
  sectionWrapper: {},
  textArea: {
    mb: ['40px', '40px', '40px', '0', '0'],
    pr: ['0', '0', '0', '80px', '100px'],
  },
  
  //Get in touch with Archer Health
  title: {
    fontSize: ['18px', '20px', '22px', '24px', '30px'],
    fontWeight: '500',
    color: '#fff',
    lineHeight: '1.34',
    mb: ['14px', '14px', '14px', '14px', '13px'],
    //textAlign: ['center', 'center', 'center', 'left', 'left'],
    textAlign: ['left'],
    //letterSpacing: '-0.025em',
    letterSpacing: '0',
  },

  //Interested in learning..?
  description: {
    fontSize: ['14px', '15px'],
    maxWidth: ['100%', '400px'],
    fontWeight: '500',
    color: '#fefefe',
    lineHeight: '1.7',
    mb: 0,
    //textAlign: ['center', 'center', 'center', 'left', 'left'],
    textAlign: ['left'],
  },
  buttonArea: {
    zIndex: 1,
  },
  buttonStyle: {
    type: 'button',
    fontSize: '14px',
    fontWeight: '700',
    pl: '30px',
    pr: '30px',
  },
};

export default Newsletter;
